import { LeafletPixiContext } from "./useLeafletPixi";
import { useEffect } from "react";
import { OperationRenderer, RendererName } from "@api/pixijs/renderers/OperationRenderer";
import { useTypedSelector } from "@hooks/useTypedSelector";
import { useActions } from "@hooks/useActions";

export default function (pixiContext: LeafletPixiContext | undefined) {
    const { works } = useTypedSelector(state => state.geoZoneTabSettings)
    const { clearOperationLayers } = useActions()
    useEffect(() => {
        if (pixiContext) {
            clearOperationLayers()
            const renderer = pixiContext.service.getRendererByName<OperationRenderer>(RendererName.Operations)
            works.enabled ? renderer.enable() : renderer.disable()
        }
    }, [pixiContext, works.enabled])
    useEffect(() => {
        if (pixiContext) {
            const renderer = pixiContext.service.getRendererByName<OperationRenderer>(RendererName.Operations)
            renderer.changeVisibility(works.current)
        }
    }, [pixiContext, works.current])
}